import React, { Component } from 'react';
import FilterSidebar from './FilterSidebar.js';
import Mii from './Mii.js';
import PlayerPopup from './PlayerPopup.js';
import Shared from './Shared.js';
import ListTable from './ListTable.js';

import { round, average } from './Utils.js';
import { withRouter } from 'react-router-dom';

const filterData = require('./data/player_filter_data.json');
const names = require('./data/names.json');
const namesLower = require('./data/names_lower.json');

// const mii_data = require('./data/miis.json');
//const nameImgs = require('./data/name_imgs.json');

class MiiSelector extends Component {
    static defaultProps = { x:30, y:30, width:1600, cols:20, size:"auto", selectWidth:6, padding:10, scale:20, count:100, offset:0 };

    constructor(props) {
        super(props);
        this.state = {selected:null,
                      mii: props.match ? props.match.params.index : -1,
                      loading:true,
                      filters:{
                          characters:[],
                          charType:"all",
                          gameType:"any",
                          characterCount:0,
                          gameCount:0,
                          minLag:"",
                          maxLag:"",
                          minWinRate:"",
                          maxWinRate:"",
                          hasData:"indeterminate",
                          hasStockData:"indeterminate",
                          hasCharData:"indeterminate",
                          hasPercentData:"indeterminate",
                          hasLagData:"indeterminate",
                          name:""
                      }
                     };

        this.miiHover = this.miiHover.bind(this);
        this.selectMii = this.selectMii.bind(this);
        this.closePopup = this.closePopup.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.filters === nextState.filters || this.state.loading != nextState.loading;
    }

    componentDidMount() {
        this.setState({loading:true});
        let that = this;

        let shared = Shared.get();
        if (shared.filters) {
            this.state.filters = shared.filters;
        }
        
        // shared.setMiisB64(mii_data);
        // shared.setNamesB64(nameImgs);
        // that.setState({loading:false});
        if (shared.miis === null) {
            fetch("https://skydereign.github.io/forglory-data/miis.json")
                .then(function(response) {
                    return response.json();
                }).then(function(data) {
                    let shared = Shared.get();
                    shared.setMiisB64(data);
                    that.setState({loading:false});
                });
        } else {
            this.setState({loading:false});
        }
    }

    miiHover(i) {
        this.setState({selected:i});
    }

    checkFilter(index) {
        let data = filterData[index];
        let filters = this.state.filters;

        if (filters["name"] !== "") {
            if (namesLower[index].indexOf(filters["name"].toLowerCase()) === -1) {
                return false;
            }
        }

        if (filters["hasData"] === "true") {
            if (data === undefined) {
                return false;
            }
        } else if (filters["hasData"] === "false") {
            if (data !== undefined) {
                return false;
            }
        }

        // we don't have data, any other active filters will be false
        if (data === undefined) {
            if (filters["gameType"] !== "any"
                || filters["characters"].length > 0
                || filters["characterCount"] !== 0
                || filters["gameCount"] !== 0
                || filters["hasPercentData"] !== "indeterminate"
                || filters["hasStockData"] !== "indeterminate"
                || filters["hasCharData"] !== "indeterminate"
                || filters["hasLagData"] !== "indeterminate"
                || (filters["minWinRate"] !== "" || filters["maxWinRate"] !== "")
                || (filters["minLag"] !== "" || filters["maxLag"] !== "")) {
                return false;
            }
        }

        let boolFilters = [["hasStockData", "has_stock_data"],
                           ["hasLagData", "has_lag_data"],
                           ["hasCharData", "has_char_data"],
                           ["hasPercentData", "has_percent_data"]];

        for (let i in boolFilters) {
            let filter = boolFilters[i];
            if (filters[filter[0]] === "true" && !data[filter[1]]) {
                return false;
            } else if(filters[filter[0]] === "false" && data[filter[1]]) {
                return false;
            }
        }


        let dataTypes = [["hasPercentData", "has_percent_data"], ["hasLagData", "has_lag_data"],
                         ["hasCharData", "has_char_data"], ["hasStockData", "has_stock_data"]];

        for (let i in dataTypes) {
            let dataType = dataTypes[i];

            if (filters[dataType[0]] === "true") {
                if (!data[dataType[1]]) {
                    return false;
                }
            } else if (filters[dataType[0]] === "false") {
                if (data[dataType[1]]) {
                    return false;
                }
            }
        }


        // if (this.state.filters.characters[0] in data["characters"] && data["2v2"] > 0) {
        //     return true;
        // }

        // only filter by character if a character is specified
        // filter requires all/any/none
        if (filters["characters"].length > 0) {
            let found = false;

            for (let charIndex in filters["characters"]) {
                let char = filters["characters"][charIndex];

                if (data["characters"].indexOf(char) >= 0) {
                    if(filters["charType"] === "none") {
                        return false;
                    }

                    found = true;
                } else if(filters["charType"] === "all") {
                    // player is missing a character
                    return false;
                }
            }

            if(!found && filters["charType"] !== "none") {
                return false;
            }
        }

        if (filters["characterCount"] !== 0 && filters["characterCount"] > Object.keys(data["characters"]).length) {
            return false;
        }

        if (filters["gameCount"] !== 0 && filters["gameCount"] > data["1v1"] + data["2v2"]) {
            return false;
        }

        switch(filters["gameType"]) {
        case "1v1":
            if(filters["gameType"] === "1v1" && !data["1v1"]) {
                return false;
            }
            break;

        case "2v2":
            if(filters["gameType"] === "2v2" && !data["2v2"]) {
                return false;
            }
            break;

        case "both":
            if(!data["2v2"] || !data["1v1"]) {
                return false;
            }
            break;

        default:
            // doesn't effect filter
            break;
        }

        // handle min/max filters
        let minMaxFilters = [["minLag", "maxLag", "average_lag", "has_lag_data"],
                             ["minWinRate", "maxWinRate", "win_rate", null]];

        for (let i in minMaxFilters) {
            let filter = minMaxFilters[i];
            if ((filters[filter[0]] !== "" || filters[filter[1]] !== "") && (filter[3] && !data[filter[3]])) {
                return false;
            }
            if (filters[filter[0]] !== "" && data[filter[2]] < filters[filter[0]]) {
                return false;
            }
            if (filters[filter[1]] !== "" && data[filter[2]] > filters[filter[1]]) {
                return false;
            }
        }

        return true;
    }

    updateFilter(key, value) {
        let filters = this.state.filters;

        if (key === "characters") {
            if (!(filters["characters"].indexOf(value) !== -1)) {
                filters["characters"].push(value);
            } else {
                filters["characters"].splice(filters["characters"].indexOf(value), 1);
            }
        } else {
            filters[key] = value;
        }

        this.setState({filters:filters});
    }

    updateAllFilters(keys) {
        let filters = this.state.filters;
        
        for (let key_i in keys) {
            console.log(key_i, keys[key_i]);
            filters[key_i] = keys[key_i];
        }
        this.setState({filters:filters});
        let shared = Shared.get();        
        shared.setFilters(filters);
    }

    selectMii(miiIndex) {
        this.setState({mii:miiIndex});
        this.props.history.push(process.env.PUBLIC_URL + "/players/" + miiIndex);
    }

    closePopup() {
        this.setState({mii:-1});
        this.props.history.push(process.env.PUBLIC_URL + "/players");
    }

    getNumGames(miiIndex) {
        if (!(miiIndex in filterData)) {
            return 0;
        }

        let data = filterData[miiIndex];
        return data["2v2"] + data["1v1"];
    }

    getCharacters(miiIndex) {
        if (!(miiIndex in filterData)) {
            return {};
        }

        return filterData[miiIndex]['characters'];
    }

    getLag(miiIndex) {
        if (!(miiIndex in filterData) || !(filterData[miiIndex]["has_lag_data"])) {
            return false;
        }

        return filterData[miiIndex]["average_lag"];
    }

    render() {
        let shared = Shared.get();
        let count = this.props.count + this.props.offset;
        let container = [];
        let selected = this.state.selected;
        let numGames = 0;
        let allChars = {};
        let allLag = [];
        
        let size = this.props.size;
        if (this.props.size === "auto") {
            size = this.props.width / this.props.cols;
        }
        size = 60;

        let selectedMiis = [];

        for (let i=this.props.offset; i<count; i++) {
            if (this.checkFilter(i)) {
                selectedMiis.push(i);
                numGames += this.getNumGames(i);

                let lag = this.getLag(i);
                if (lag && lag < 60 && lag >= 0) { // remove outliers
                    allLag.push(lag);
                }
                let characters = this.getCharacters(i);

                for (let charI in characters) {
                    let char = characters[charI];

                    if (!(char in allChars)) {
                        allChars[char] = 0;
                    }

                    allChars[char] += 1;
                }
            }
        }

        for (let i=0; i<selectedMiis.length; i++) {
            let mii = selectedMiis[i];

            if (mii !== selected) {
                container.push(<Mii loading={this.state.loading} src={shared.getMiiB64(mii)} name={names[mii]} nameImg={shared.getNameB64(mii)} selected={this.selectMii} key={i} i={mii} width={size} height={size} />);
            }
        }

        let mostPopularCharacter = Object.keys(allChars).reduce((a, b) => allChars[a] > allChars[b] ? a : b, "None");
        let resultsList = [
            ["Miis", `${selectedMiis.length} (${round(100.0*selectedMiis.length / count, 2)}%)`],
            ["Games", numGames],
            ["Average Lag", `${round(average(allLag), 2)}s`],
            ["Most Represented", mostPopularCharacter]
        ];

        let results = (
            <div>
              <h2>Results</h2>
              <ListTable classes={["td-right"]} fixed={true} list={resultsList} />
            </div>
        );

        let popup = this.state.mii >= 0 ? <PlayerPopup close={this.closePopup} i={this.state.mii}/> : "";

        return (
            <div className="MiiSelector">
              <FilterSidebar updated={this.updateAllFilters.bind(this)}
                             results={results} />

              <div className="MiiView">
                {container}
              </div>

              { popup }
                 
                  
            </div>
        );
    }
}


export default withRouter(MiiSelector);
